export const SmartInsightsRoute = {
  SMARTINSIGHTS: 'smartinsights',
};

export const SmartInsightsPathName = {
  SMARTINSIGHTS: 'smartinsights',
};

export const SmartInsightsStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  SKIPPED_NO_DATA: 'SKIPPED_NO_DATA',
  SKIPPED_NO_DASHBOARD: 'SKIPPED_NO_DASHBOARD',
  FAILED: 'FAILED',
};

export const SmartInsightsStatusLabels = {
  [SmartInsightsStatus.PENDING]: 'Pending',
  [SmartInsightsStatus.IN_PROGRESS]: 'In Progress',
  [SmartInsightsStatus.SUCCESS]: 'Success',
  [SmartInsightsStatus.SKIPPED_NO_DATA]: 'Skipped - No Data',
  [SmartInsightsStatus.SKIPPED_NO_DASHBOARD]: 'Skipped - No Dashboard',
  [SmartInsightsStatus.FAILED]: 'Failed',
};

export const SmartInsightsLogFilter = {
  ALL: 'ALL',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
};

export const SmartInsightsStatusColors = {
  [SmartInsightsStatus.PENDING]: 'is-warning',
  [SmartInsightsStatus.IN_PROGRESS]: 'is-info',
  [SmartInsightsStatus.SUCCESS]: 'is-success',
  [SmartInsightsStatus.SKIPPED_NO_DATA]: 'is-light',
  [SmartInsightsStatus.SKIPPED_NO_DASHBOARD]: 'is-light',
  [SmartInsightsStatus.FAILED]: 'is-danger',
};
